// extracted by mini-css-extract-plugin
export default {"taskLayout":"TaskLayout_taskLayout__layZH"};